<template>
  <g>
    <path
      d="M15.4102 7.41L10.8302 12L15.4102 16.59L14.0002 18L8.00016 12L14.0002 6L15.4102 7.41Z"
    />
  </g>
</template>
